import { Injectable } from '@angular/core';
import { DeviceInfo } from '../models/devices/device_info';

@Injectable({
  providedIn: 'root'
})
export class DeviceDetectionService {

  constructor() { }

  getDeviceInfo(): DeviceInfo {
    const userAgent = navigator.userAgent.toLowerCase();
    const isAndroid = userAgent.includes('android');
    const isIOS = userAgent.includes('iphone') || userAgent.includes('ipad');

    return {
      isAndroid,
      isIOS,
      isMobile: isAndroid || isIOS
    };
  }

  shouldRedirectToAppNotInstalled(): boolean {
    const deviceInfo = this.getDeviceInfo();
    const isFromRedirect = !document.referrer || document.referrer.trim() === '';
    
    return deviceInfo.isMobile && isFromRedirect;
  }
}
